import { useTranslation } from 'react-i18next';

import { CommentSearchResult } from '@/shared/components/comments/CommentSearchResult';
import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

/**
 * A comment on a post in the global search results (entity type `comment`; meta: postId, postTitle). It has the visibility of
 * its post; the row opens the post.
 */
export function PostCommentSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('feed');
  const title = result.meta?.postTitle ?? '';
  return (
    <CommentSearchResult
      result={result}
      highlights={highlights}
      heading={title ? t('search.commentOnPost', { title }) : t('search.commentOnPostUntitled')}
    />
  );
}
